import { render } from "./TotalProjects.vue?vue&type=template&id=c4904dbc&ts=true"
import script from "./TotalProjects.vue?vue&type=script&lang=ts"
export * from "./TotalProjects.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__